import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ProceduresService } from '../procedures.service';
import { FlashMessageWrapperService } from '../../../app/shared/services/flash-message-wrapper.service';

@Component({
    selector: 'app-manageprocedure-screen',
    templateUrl: './manageprocedure.screen.component.html',
    styleUrls: ['./manageprocedure.screen.component.scss'],
    providers: [
        ProceduresService
    ],
    standalone: false
})

export class ManageProcedureScreenComponent implements OnInit {

    procedureName: string = '';
    isValid: boolean = true;
    formValidationList: any = {
        procedureName: ''
    };

    constructor(
        private _procedureService: ProceduresService,
        private spinner: NgxSpinnerService,
        private _flashMessagesService: FlashMessageWrapperService,
        public activeModal: NgbActiveModal
    ) {}

    ngOnInit() {}

    // Validate procedure name
    performProcedureValidation() {

        this.isValid = true;
        this.formValidationList.procedureName = '';

        if (!this.procedureName || !this.procedureName.trim()) {
            this.formValidationList.procedureName = 'This field is required!';
            this.isValid = false;
        }

        return this.isValid;
    }

    // Add new procedure
    submitForm() {

        if (!this.performProcedureValidation()) {
            return;
        }
        this.spinner.show();

        const params = {
            procedureName: this.procedureName.trim()
        };

        this._procedureService.addProcedure(params).subscribe(
            (data) => {
                this.spinner.hide();
                if (data.status === 'success') {
                    this._flashMessagesService.show(data.message,
                        {
                            cssClass: 'alert-success',
                            timeout: 4000
                        }
                    );
                    this.closePopup();
                } else {
                    this._flashMessagesService.show(data.message || 'Something went wrong!',
                        {
                            cssClass: 'alert-danger',
                            timeout: 4000
                        }
                    );
                }
            },
            (error) => {
                console.log(error);
                this.spinner.hide();
            }
        );
    }

    // Close popup
    closePopup() {
        this.activeModal.close('Close click');
    }
}